const s = {
  name: "GhanaianCedi",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,11.1c-2.3,0.5-4,2.5-4,4.9v8c0,2.4,1.7,4.4,4,4.9V31h2v-2.1c2.3-0.5,4-2.5,4-4.9h-2c0,1.3-0.8,2.4-2,2.8
			V13.2c1.2,0.4,2,1.5,2,2.8h2c0-2.4-1.7-4.4-4-4.9V9h-2V11.1z M19,13.2v13.7c-1.2-0.4-2-1.5-2-2.8v-8C17,14.7,17.8,13.6,19,13.2z"
			/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as GhanaianCedi
};
